var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react/require-default-props */
import DynamicFilterDropdown from '@/shared/components/DynamicFilterDropdown';
import React, { useMemo, useState } from 'react';
import { FaUndo } from 'react-icons/fa';
import { defineMessages, useIntl } from 'react-intl';
import { dynamicSort } from '@/shared/utils/dynamicSort';
import userStorage from '../services/userStorage';
import { FilterSave } from './FilterSave';
import { WeekPlannerFilterType } from '@/modules/tasks/weekplanner/constants';
var onlyUnique = function (value, index, self) { return self.indexOf(value) === index; };
var selectAll = 'selectAll';
var messages = defineMessages({
    ResetFilters: {
        id: 'ResetFilters',
        defaultMessage: 'Reset filters',
    },
    SelectAll: {
        id: 'SelectAll',
        defaultMessage: 'Select all',
    },
});
export var FilterWrapper = function (_a) {
    var filterObject = _a.filterObject, children = _a.children, bottomElement = _a.bottomElement, screen = _a.screen, setFilter = _a.setFilter, hasActiveFilters = _a.hasActiveFilters, resetFilters = _a.resetFilters, invisibleFilters = _a.invisibleFilters;
    var formatMessage = useIntl().formatMessage;
    var filterSelectItems = useMemo(function () {
        return children.filter(function (item) { return item.filterSelectLabel && item.enabled; }).map(function (item) { return item.filterItem; });
    }, [children]);
    var _b = useState(userStorage.getItem("".concat(screen, "-Filters")) || []), selectedFilterItems = _b[0], _setSelectedFilterItems = _b[1];
    var setSelectedFilterItems = function (items) {
        return _setSelectedFilterItems(function (prev) {
            var newItems = typeof items === 'function' ? items(prev) : items;
            userStorage.setItem("".concat(screen, "-Filters"), newItems);
            return newItems;
        });
    };
    var filterSelectList = useMemo(function () { return __spreadArray([
        {
            id: selectAll,
            label: formatMessage(messages.SelectAll),
            selected: selectedFilterItems.includes(selectAll),
        }
    ], filterSelectItems
        .map(function (key) { return ({
        id: key,
        label: children.find(function (item) { return item.filterItem === key; }).filterSelectLabel,
        selected: selectedFilterItems.includes(key),
    }); })
        .sort(dynamicSort('label')), true); }, [children, filterSelectItems, formatMessage, selectedFilterItems]);
    var onChangeFilterSelect = function (selectedItem, selected, visibleItemIds) {
        if (selectedItem.id === selectAll) {
            if (visibleItemIds) {
                // Search-filtered select all: only toggle visible items
                if (selected) {
                    setSelectedFilterItems(function (prev) {
                        var newItems = __spreadArray(__spreadArray([], prev, true), visibleItemIds.filter(function (id) { return !prev.includes(id); }), true);
                        if (newItems.filter(function (id) { return id !== selectAll; }).length >= filterSelectItems.length) {
                            return __spreadArray([selectAll], filterSelectItems, true);
                        }
                        return newItems;
                    });
                }
                else {
                    setSelectedFilterItems(function (prev) {
                        return prev.filter(function (item) { return item === selectAll ? false : !visibleItemIds.includes(item); });
                    });
                }
            }
            else if (selected) {
                setSelectedFilterItems(__spreadArray([selectAll], filterSelectItems, true));
            }
            else {
                setSelectedFilterItems([]);
            }
        }
        else {
            // eslint-disable-next-line no-lonely-if
            if (selected) {
                if (selectedFilterItems.length + 1 >= filterSelectItems.length) {
                    setSelectedFilterItems(__spreadArray([selectAll], filterSelectItems, true));
                }
                else {
                    setSelectedFilterItems(function (prev) { return __spreadArray(__spreadArray([], prev, true), [selectedItem.id], false); });
                }
            }
            else {
                setSelectedFilterItems(function (prev) {
                    return prev.filter(function (item) { return item !== selectedItem.id && item !== selectAll; });
                });
            }
        }
    };
    var includedFilterKeys = useMemo(function () {
        return __spreadArray(__spreadArray(__spreadArray([], children.map(function (item) { return item.filterItem; }), true), children.reduce(function (prev, item) { var _a; return __spreadArray(__spreadArray([], prev, true), ((_a = item.extraFilterItems) !== null && _a !== void 0 ? _a : []), true); }, []), true), invisibleFilters, true).filter(onlyUnique);
    }, [children, invisibleFilters]);
    var includedFiltersObject = useMemo(function () {
        return Object.keys(filterObject).reduce(function (prev, key) {
            var _a;
            if ((!filterObject[key] || !includedFilterKeys.includes(key)) && filterObject[key] !== 0) {
                return prev;
            }
            return __assign(__assign({}, prev), (_a = {}, _a[key] = filterObject[key], _a));
        }, {});
    }, [filterObject, includedFilterKeys]);
    var internalHasActiveFilters = useMemo(function () {
        return !!hasActiveFilters
            ? hasActiveFilters()
            : Object.keys(includedFiltersObject)
                .filter(function (item) {
                return item !== WeekPlannerFilterType.executionDateFrom &&
                    item !== WeekPlannerFilterType.executionDateUntil;
            })
                .map(function (item) { return includedFiltersObject[item]; })
                .filter(function (item) { return (Array.isArray(item) ? item.length > 0 : item === 0 || Boolean(item)); })
                .length > 0;
    }, [includedFiltersObject]);
    var internalResetFilters = resetFilters ||
        (function () {
            setFilter(includedFilterKeys.reduce(function (prev, item) {
                var _a;
                return (__assign(__assign({}, prev), (_a = {}, _a[item] = item === WeekPlannerFilterType.executionDateFrom ||
                    item === WeekPlannerFilterType.executionDateUntil
                    ? filterObject[item]
                    : undefined, _a)));
            }, {}));
        });
    return (_jsxs(React.Fragment, { children: [_jsx("div", __assign({ className: "row" }, { children: children
                    .filter(function (x) { return x.filterItem; })
                    .map(function (child) {
                    var _a;
                    if (!child.element) {
                        return null;
                    }
                    if (child.filterSelectLabel &&
                        !selectedFilterItems.includes(child.filterItem)) {
                        return null;
                    }
                    return (_jsx("div", __assign({ className: (_a = child.className) !== null && _a !== void 0 ? _a : 'col-lg-3 col-md-6' }, { children: _jsx("div", __assign({ className: "form-group width100pct" }, { children: child.element })) }), child.filterItem));
                })
                    .filter(Boolean) })), _jsxs("div", __assign({ className: "flex-row" }, { children: [_jsxs("div", __assign({ className: "btn-group save-filters" }, { children: [_jsx(FilterSave, { hasActiveFilters: internalHasActiveFilters, screen: screen, filtersObject: includedFiltersObject, resetFilters: internalResetFilters, setFilter: setFilter }), filterSelectItems.length > 0 && (_jsx(DynamicFilterDropdown, { items: filterSelectList, onChange: onChangeFilterSelect })), internalHasActiveFilters && (_jsxs("button", __assign({ type: "button", className: "btn btn-default btn-reset", onClick: internalResetFilters }, { children: [_jsx(FaUndo, { className: "react-icon fa-fw margin5R" }), formatMessage(messages.ResetFilters)] })))] })), bottomElement] }))] }));
};
